import { IFilter } from './iFilter';
export class UserFilter implements IFilter {
  constructor(public key = '', public value = '', public origin = '') {}
}
